import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timer"]
  static values = {
    seconds: { type: Number, default: 15 },
    url: String
  }

  connect() {
    this.remainingTime = this.secondsValue
    this.updateDisplay()
    this.startCountdown()
  }

  startCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
    
    this.countdownInterval = setInterval(() => {
      this.remainingTime -= 1
      
      if (this.remainingTime <= 0) {
        clearInterval(this.countdownInterval)
        this.redirect()
      } else {
        this.updateDisplay()
      }
    }, 1000)
  }

  updateDisplay() {
    if (this.hasTimerTarget) {
      this.timerTarget.textContent = this.remainingTime
    }
  }

  redirect() {
    window.location.href = this.urlValue
  }

  disconnect() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  }
}
